<template>
  <div>
    <div class="bodyTopBox">
      <div class="bodyTopBox1">
        <img src="../../../static/image/sel.png" class="bodyTopBox1_1" />
        <input v-model="ssinput" placeholder="请输入搜索的产品" class="bodyTopBox1_2"></input>
        <div class="bodyTopBox1_3" @click="selButton"></div>
      </div>
    </div>
    <div class="bodyBox">
      <div class="shopBox">
        <div class="shopBoxl">
          <div class="shopBoxl1">
            <div class="shopName">肯德基(北四路店)</div>
          </div>
          <div class="shopBoxl1">
            营业时间：&nbsp;6:00-23:00
          </div>
          <div class="shopBoxl1">
            距离：&nbsp;2.3km &nbsp;&nbsp; 沈阳市铁西区
          </div>
          <div class="shopBoxl1">
            销量：&nbsp;5210
          </div>
        </div>
        <img src="../../../static/image/logo.png" class="shopBoxr"/>
      </div>
    </div>
    <div class="goodsBox">
      <div class="goods" v-for="item in 5" >
        <img src="http://p1.meituan.net/codeman/826a5ed09dab49af658c34624d75491861404.jpg" class="goodsImg" />
        <div class="goodsInformationBox">
          <div class="goodsName">红烧肉炖豆角</div>
          <div style="height: 30px;"></div>
          <div style="goodsInformation">点赞:200 &nbsp;&nbsp;销量:500</div>
          <div class="goodsPrice">￥50 <span style="font-size: 14px; text-decoration:line-through;color: #999999;">￥100</span></div>
        </div>
        <div class="goodsPayBox">
          <div class="Pay">立即购买</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },

    //初始化
    created(){

    },
    methods:{
      // 搜索
      selButton(){
        console.log("搜索")
      },
    }
  }
</script>

<style scoped>
  input{
    box-shadow:none;
    outline: none;
    resize: none;
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    border-radius: 0;
  }
  .bodyTopBox{
    width: 100%;
    height: 100px;
    margin: 0px auto;
    box-shadow: 0px 5px 10px #ccc;
    background-color: #FFFFFF;
  }
  .bodyTopBox1{
    width:1200px;
    height: 100px;
    position: relative;
    margin: 0px auto;
  }
  .bodyTopBox1_1{
    width:1200px;
    height: 100px;
  }
  .bodyTopBox1_2{
    position: absolute;
    top: 30px;
    left: 370px;
    width: 640px;
    height: 40px;
    font-size: 18px;
  }
  .bodyTopBox1_3{
    width: 75px;
    height: 48px;
    position: absolute;
    top: 28px;
    left: 1028px;
  }
  .bodyBox{
    width: 1200px;
    background-color: #FFFFFF;
    margin: 20px auto 0px;
    border-radius: 5px;
  }
  .shopBox{
    display: flex;
    justify-content: space-between;
    width: 1120px;
    padding: 20px 40px;
  }
  .shopBoxl{
    width: 1000px;
  }
  .shopBoxl1{
    display: flex;
    align-items: center;
    line-height: 40px;
    font-size: 18px;
    color: #333333;
  }
  .shopName{
    font-weight: 600;
    font-size: 30px;
    line-height: 50px;
  }
  .shopBoxr{
    width: 100px;
    height: 100px;
  }
  .goodsBox{
    width: 1200px;
    margin: 10px auto 0px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .goods{
    width: 595px;
    height: 150px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
  }
  .goodsImg{
    width: 130px;
    height: 130px;
    margin: 10px;
    border-radius: 10px;
    display: block;
  }
  .goodsInformationBox{
    padding: 10px 0;
    width: 295px;
    height: 130px;
  }
  .goodsName{
    width: 295px;
    height: 30px;
    font-size: 20px;
    font-weight: 600;
  }
  .goodsInformation{
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    color: #666666;
  }
  .goodsPrice{
    font-size: 30px;
    height: 40px;
    line-height: 40px;
    color: #F30213;
  }
  .goodsPayBox{
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .Pay{
    width: 120px;
    height: 45px;
    border-radius: 45px;
    color: #FFFFFF;
    background-color: #FD8723;
    text-align: center;
    line-height: 45px;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingMall/shop.vue